// UserCategoriesCategory.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import UniversalComponent from '../component/UniversalComponent.jsx';
import { createCategoryLoader } from '../resource/createCategoryLoader.js';
import useSSRDataMerge from '../hook/useSSRDataMerge.js';

export const loader = createCategoryLoader({
  pathPrefix: 'user-categories',
  categoryType: 'creators',
  loaderName: 'UserCategoriesCategory',
});

const UserCategoriesCategoryRoute = () => {
  const { data, error } = useLoaderData();

  useSSRDataMerge({
    componentName: 'UserCategoriesCategory',
    loaderData: data,
    loaderError: error,
  });

  return (
    <UniversalComponent
      filename="Container_UserMore"
      importer={/* #__LOADABLE__ */ () => import('../container/UserMore.js')}
    />
  );
};

export default UserCategoriesCategoryRoute;
